import Container from 'components/elements/containers/container'
import SitemapLinksContainer from 'components/elements/containers/sitemap-links-container'
import SitemapLink from 'components/links/sitemap-link'
import * as href from 'lib/constants/hrefs'
import Head from 'next/head'

const Sitemap = () => {
  return (
    <>
      <Head>
        <title>Tella | Sitemap</title>
      </Head>
      <Container containerClass="mt-10">
        <div className="mx-auto grid gap-10 sm:w-11/12">
          <div>
            <h1 className="font-semibold">Tella Site Map</h1>
            <div className="mt-2 h-[1px] w-full bg-tella-blue-100"></div>
          </div>
          <SitemapLinksContainer title="Home">
            <SitemapLink text="Home Loans" href={href.HL_MORTGAGES} hasChildPages />
            <SitemapLink text="About Us" href={href.ABOUT_US} />
            <SitemapLink text="Contact Us" href={href.CONTACT_US} />
            <SitemapLink text="FAQS" href={href.FAQS} />
            <SitemapLink text="Important Info" href={href.IMPORTANT_INFO} />
          </SitemapLinksContainer>

          <SitemapLinksContainer title="Home Loans">
            <SitemapLink text="First Home" href={href.FIRST_HOME} />
            <SitemapLink text="Refinance" href={href.REFINANCE} />
            <SitemapLink text="Investment" href={href.LEARN_PROPERTY_INVESTMENT} />
            <SitemapLink text="Calculators" href={href.CALCULATORS} hasChildPages />
            <SitemapLink text="Learn" href={href.LEARN} hasChildPages />
            <SitemapLink text="Rates" href={href.RATES} />
          </SitemapLinksContainer>

          <SitemapLinksContainer title="Learn">
            <SitemapLink text="Buying your first home" href={href.LEARN_FIRST_HOME_BUYER} hasChildPages />
            <SitemapLink
              text="Moving house or switching bank"
              href={href.LEARN_MOVING_HOUSE_SWITCHING_BANKS}
              hasChildPages
            />
            <SitemapLink text="Buying investment property" href={href.LEARN_PROPERTY_INVESTMENT} hasChildPages />
            <SitemapLink text="Helping the kids buy a home" href={href.LEARN_HELPING_KIDS_BUY_HOME} hasChildPages />
          </SitemapLinksContainer>

          <SitemapLinksContainer title="Calculators">
            <SitemapLink text="First Home Deposit" href={href.CALC_FIRST_HOME_DEPOSIT} />
            <SitemapLink text="Affordability" href={href.CALC_AFFORDABILITY} />
            <SitemapLink text="Repayment" href={href.CALC_REPAYMENT} />
          </SitemapLinksContainer>
        </div>
      </Container>
    </>
  )
}

export default Sitemap
